import React from 'react';

export interface TermsSection {
  /** the DOM id of the section in the terms list */
  id: string;
  title: React.ReactNode;
  /** a heading among the chips (e.g. the flight route) rather than a link */
  isGroup?: boolean;
}

/**
 * The sections of a terms popup as a row of chips above the text (sticky while it scrolls): a tap scrolls to that
 * section in whatever scrolls - the list on desktop, the bottom sheet on phones. Replaces antd Anchor, which waited
 * for a second render to appear and squeezed the text into a narrow column next to it.
 */
const TermsSectionNav: React.FC<{ sections: TermsSection[] }> = ({ sections }) => {
  if (sections.length < 2) {
    return null;
  }
  const goTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  return (
    <nav className="terms-section-nav">
      {sections.map((section) =>
        section.isGroup ? (
          <span key={section.id} className="terms-section-nav__group">
            {section.title}
          </span>
        ) : (
          <button
            key={section.id}
            type="button"
            className="terms-section-nav__chip"
            onClick={() => goTo(section.id)}
          >
            {section.title}
          </button>
        )
      )}
    </nav>
  );
};

export default TermsSectionNav;
